import { FC } from "react";
import {
    Box,
    Container,
    Flex,
    Heading,
    Text,
    VStack,
    Image,
    HStack,
    IconButton,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faFacebook } from "@fortawesome/free-brands-svg-icons";
import WhatsAppButton from "../../components/WhatsAppButton/WhatsAppButton";

const Home: FC = () => {
    return (
        <Box bg="color.50" height="100vh" display="flex" alignItems="center">
            <Container maxW="1200px" px={4}>
                <Flex
                    direction={{ base: "column", md: "row" }}
                    align="center"
                    justify="space-between"
                    height="100%"
                >
                    {/* Lado esquerdo - texto e ícones */}
                    <Flex
                        flex="1"
                        direction="column"
                        align={{ base: "center", md: "flex-start" }}
                        pr={{ base: 0, md: 12 }}
                        textAlign={{ base: "center", md: "left" }}
                        color="gray.800"
                        height="60vh"
                        px={{ base: 4, md: 5 }}
                    >
                        {/* Parte de cima maior */}
                        <Box
                            flex="10"
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"

                        >
                            <Heading
                                as="h1"
                                fontSize={{ base: "3xl", md: "5xl" }}
                                fontWeight="bold"
                                color="color.500"
                                textTransform="uppercase"
                                textShadow="1px 1px 2px rgba(0,0,0,0.15)"
                            >
                                Donna Cegonha
                            </Heading>

                            <Text
                                fontSize={{ base: "md", md: "xl" }}
                                fontWeight="medium"
                                color='gray.600'
                                mt={4}
                                lineHeight="taller"
                            >
                                Arte feita à mão com carinho e dedicação.
                                Transforme momentos em lembranças inesquecíveis com nossos produtos exclusivos.
                            </Text>

                            <Box mt={6}>
                                <WhatsAppButton />
                            </Box>
                        </Box>

                        <Box mt={12}>
                            <HStack spacing={2}>
                                <IconButton
                                    as="a"
                                    href="https://www.instagram.com/donna.cegonha_/"
                                    target="_blank"
                                    aria-label="Instagram"
                                    icon={<FontAwesomeIcon icon={faInstagram} style={{ fontSize: "2rem" }} />}
                                    size="lg"
                                    color="color.500"
                                    bg="none"
                                    _hover={{ color: 'color.600' }}
                                    _active={{ bg: 'none' }}
                                />
                                <IconButton
                                    as="a"
                                    href="https://www.facebook.com/donnacegonha/"
                                    target="_blank"
                                    aria-label="Facebook"
                                    icon={<FontAwesomeIcon icon={faFacebook} style={{ fontSize: "2rem" }} />}
                                    size="lg"
                                    color="color.500"
                                    bg="none"
                                    _hover={{ color: 'color.600' }}
                                    _active={{ bg: 'none' }}
                                />
                            </HStack>
                        </Box>
                    </Flex>

                    {/* Lado direito - imagem ocupando toda a altura */}
                    <Box
                        flex="1"
                        height={{ base: "300px", md: "100%" }}
                        display={{ base: "none", md: "flex" }} // <--- aqui
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Image
                            src={require("../../assets/img/artesanato/banner-artesanato.jpg")}
                            alt="Artesanato Donna Cegonha"
                            objectFit="cover"
                            w="100%"
                            h="100%"
                            borderRadius="xl"
                            boxShadow="lg"
                        />
                    </Box>
                </Flex>
            </Container>
        </Box>
    );
};

export default Home;
